export const COMING_SOON_STYLES = {
  root: "relative w-full overflow-hidden rounded-t-[24px] [container-type:inline-size]",
  frame: "relative w-full aspect-[1512/560] min-h-[200px]",
  background: "absolute inset-0 h-full w-full object-cover",
  logoWrapper:
    "pointer-events-none absolute inset-x-0 top-0 flex justify-center opacity-20",
  logo: "h-auto w-[32%] max-w-[480px] object-contain",
  orbits: "pointer-events-none absolute inset-0 h-full w-full",
  content: "absolute inset-0",
  primaryText:
    "absolute left-[29.7%] top-[32%] text-[9.2cqw] font-bold leading-none tracking-tight text-ticketon-blue",
  secondaryText:
    "absolute left-[48.4%] top-[51%] text-[9.2cqw] font-bold leading-none tracking-tight text-ticketon-blue",
  bubble:
    "absolute flex aspect-square w-[5.7%] min-w-[22px] items-center justify-center rounded-full bg-orange-dark shadow-md",
  bubbleIcon: "h-1/2 w-1/2 text-white",
} as const;

export const COMING_SOON_BUBBLE_POSITIONS = {
  luggage: "left-[37.83%] top-[13.39%]",
  flight: "left-[50.6%] top-[15%]",
  kingBed: "left-[59.66%] top-[31.96%]",
  localActivity: "left-[31.61%] top-[58.39%]",
  globe: "left-[39.15%] top-[58.39%]",
  directionsCar: "left-[48.02%] top-[75.54%]",
  percent: "left-[38.82%] top-[81.43%]",
} as const;
